import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { WALLET_CONNECT_READ_DISCLAIMER } from "src/app/angular-wallet-base/constants";
import { StorageService } from "src/app/angular-wallet-base/services/storage.service";

//TODO: This file requires cleanup. It's got a lot of unused code duplicated from modal-request.component.ts
@Component({
  selector: "disclaimer-modal",
  templateUrl: "./disclaimer-modal.component.html",
  styleUrls: ["./disclaimer-modal.component.scss"],
})
export class ModalDisclaimerComponent implements OnInit {
    constructor(
        private modalController: ModalController,
        private storageService: StorageService
    ) {
    }

    ngOnInit() {
    }

    async onClose() {
        //check if storage service has readDisclaimer
        const readDisclaimer = await this.storageService.get(WALLET_CONNECT_READ_DISCLAIMER);
        if (!readDisclaimer) {
            this.storageService.set(WALLET_CONNECT_READ_DISCLAIMER, true);
        }
        this.modalController.dismiss();
    }
}